import { Box } from "@mui/material";
import QuestionBlock from "./QuestionBlockMinimal";
import { useAppSelector } from "../../../Redux/hooks";
import { QuestionListStyle } from "../question.style";
import "./questionpreview.scss";
import MobilePreview from "../MobilePreview/MobilePreview";

const QBPreviewQuestions = () => {
  const questions = useAppSelector((state) => state.question.questions);
  const formCategory = useAppSelector((state) => state.question.formCategory);

  return (
    <Box sx={{ display: "flex", width: "100%", height: "100%" }}>
      <Box sx={{ ...QuestionListStyle, flex: 1, p: 2 }}>
        {questions.length > 0
          ? questions
              .filter((question) => !question.properties.isHidden)
              .map((q, index) => {
                return <QuestionBlock question={q} index={index} key={q.id} />;
              })
          : null}
      </Box>
      {formCategory === "survey" && <MobilePreview />}
    </Box>
  );
};

export default QBPreviewQuestions;
